import { combineReducers } from 'redux';

import * as routing from './routing';
import * as members from './member';
import * as blogs from './blog';
import * as banners from './banner';
import * as events from './events';
import * as login from './login';
import * as records from './records';
import * as receiptForm from './receiptForm';

// For Global State interface
export interface State {
	blogs: blogs.State;
	banners: banners.State;
	members: members.State;
	routing: routing.State;
	events: events.State;
	login: login.State;
	records: records.State;
	receiptForm: receiptForm.State;
}

export type GetState = () => State;

export const defaultState: State = {
	blogs: blogs.defaultState,
	banners: banners.defaultState,
	members: members.defaultState,
	routing: routing.defaultState,
	events: events.defaultState,
	login: login.defaultState,
	records: records.defaultState,
	receiptForm: receiptForm.defaultState,
};

const reducers = combineReducers<State>({
	...routing.reducer,
	...members.reducer,
	...blogs.reducer,
	...banners.reducer,
	...events.reducer,
	...login.reducer,
	...records.reducer,
	...receiptForm.reducer,
});

export default reducers;
